export const UPDATE_HOTBAR_FILTER =
	'SALES_CONTROL/UPDATE_HOTBAR_FILTER';
	
export function updateHotbarFilter(payload) {
	return {
		type: UPDATE_HOTBAR_FILTER,
		payload
	};
}
